/**
 * Normalisation des numéros de PV (format officiel : 000123/2026).
 * Les années sur 2 chiffres sont toujours interprétées comme 20xx.
 */

const REPORT_NUMBER_LENGTH = 6;

/**
 * "123" -> "000123". Retourne null si la saisie n'est pas un numéro valide.
 */
export const normalizeReportNumber = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (!digits || digits.length > REPORT_NUMBER_LENGTH || /^0+$/.test(digits)) return null;
  return digits.padStart(REPORT_NUMBER_LENGTH, '0');
};

/**
 * "26" -> "2026", "2026" -> "2026". Retourne null si la saisie n'est pas une année valide.
 */
export const normalizeReportYear = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length === 2) return `20${digits}`;
  if (digits.length === 4) return digits;
  return null;
};

/**
 * Découpe une saisie du champ numéro contenant un "/" (ex. "123/26" tapé ou collé).
 * year vaut null si aucun "/" n'a été saisi.
 */
export const splitReportInput = (value) => {
  const [numberPart, yearPart] = String(value ?? '').split('/');
  return {
    number: numberPart.replace(/\D/g, ''),
    year: yearPart === undefined ? null : yearPart.replace(/\D/g, '').slice(0, 4),
  };
};
